module.exports = __webpack_public_path__ + "media/tile-5-image.27ccd59b.webp";